import { getAdminApiKey } from "./admin-settings.js";
import { getAdminJwt } from "./auth-storage.js";

/** JSON request headers for governance routes (admin JWT or break-glass API key). */
export function governanceHeadersJson(): HeadersInit {
  const h: Record<string, string> = {
    "Content-Type": "application/json",
    /** Custom header for dashboard-originated mutating requests (SEC-07 baseline with SameSite cookies). */
    "X-IA-Dashboard": "1",
  };
  const jwt = getAdminJwt();
  if (jwt) {
    h.Authorization = `Bearer ${jwt}`;
    return h;
  }
  const key = getAdminApiKey();
  if (key) {
    h.Authorization = `Bearer ${key}`;
  }
  return h;
}

/** Read-only governance headers (GET/list endpoints). */
export function governanceHeadersAuth(): HeadersInit {
  const h: Record<string, string> = {
    "X-IA-Dashboard": "1",
  };
  const jwt = getAdminJwt();
  if (jwt) {
    h.Authorization = `Bearer ${jwt}`;
    return h;
  }
  const key = getAdminApiKey();
  if (key) {
    h.Authorization = `Bearer ${key}`;
  }
  return h;
}
